import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';

export const useFetchMyWeeklyBudget = () => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['my-weekly-budget'],
    queryFn: () => {
      return get(API_URLS.MY_WEEKLY_BUDGET);
    },
  });

  return { data: error ? [] : (data?.data ?? []), isLoading, error, refetch };
};
